import React, { useState } from "react";
import styled from "styled-components";
import Pic from "assets/images/gb.png";
import FR from "assets/images/fr.png";
import ES from "assets/images/ES.png";
import { useNavigate } from "react-router-dom";

// Mapping of language codes to flag images.
const imageMap = {
  EN: Pic,
  FR: FR,
  ES: ES,
};

// Mapping of language codes to display names.
const displayMap = {
  EN: "English",
  FR: "Français",
  ES: "Español",
};

const Language = ({ language, setLanguage, allLanguages }) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  // Returns the flag image for a given language code; defaults to Pic if not available.
  const getPic = (lang) => {
    return imageMap[lang] || Pic;
  };

  const toggleDropdown = () => {
    setOpen(!open);
  };

  const handleSelectLanguage = (lang) => {
    setLanguage(lang);
    setOpen(false);

    // Navigation logic (adjust as needed).
    if (lang === "FR") {
      navigate(`?language=1`, { replace: true });
    } else if (lang === "EN") {
      navigate(`?language=0`, { replace: true });
    } else if (lang === "ES") {
      navigate(`?language=2`, { replace: true });
    }
  };

  return (
    <Container>
      <InnerContainer onClick={toggleDropdown}>
        <Image src={getPic(language)} alt={`${language} flag`} />
        <Text>{displayMap[language] || language}</Text>
      </InnerContainer>
      <Options open={open} onClick={(e) => e.stopPropagation()}>
        {allLanguages.map((lang) => (
          <Option key={lang} onClick={() => handleSelectLanguage(lang)}>
            <OptionInner>
              <OptionImage src={getPic(lang)} alt={`${lang} flag`} />
              <OptionText>{displayMap[lang] || lang}</OptionText>
            </OptionInner>
          </Option>
        ))}
      </Options>
    </Container>
  );
};

export default Language;

const Container = styled.div`
  position: absolute;
  top: 15px;
  right: 30px;
  cursor: pointer;
  z-index: 10000;
`;

const InnerContainer = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;

const Image = styled.img`
  width: 24px;
  margin-right: 8px;
`;

const Text = styled.div`
  font-weight: 600;
  font-size: 16px;
  color: #2a3039;
`;

const Options = styled.div`
  display: ${(props) => (props.open ? "flex" : "none")};
  flex-direction: column;
  background: white;
  border-radius: 8px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  position: absolute;
  top: 40px;
  right: 0;
`;

const Option = styled.div`
  padding: 8px 16px;
  font-size: 16px;
  color: #2a3039;
  cursor: pointer;
  &:hover {
    background: #ebf1fd;
  }
`;

const OptionInner = styled.div`
  display: flex;
  align-items: center;
`;

const OptionImage = styled.img`
  width: 24px;
  margin-right: 8px;
`;

const OptionText = styled.div``;
